import { useCallback, useState } from 'react';
import { SHOWREEL_ITEMS, type ShowreelItem } from '../../content/showreel';
import { ShowreelModal } from './ShowreelModal';
import { ShowreelTile } from './ShowreelTile';

export function ShowreelGrid() {
  const [playingId, setPlayingId] = useState<string | null>(null);
  const [unmutedId, setUnmutedId] = useState<string | null>(null);
  const [dialogIndex, setDialogIndex] = useState<number | null>(null);

  const dialogOpen = dialogIndex !== null;
  const dialogItem =
    dialogIndex !== null ? SHOWREEL_ITEMS[dialogIndex] ?? null : null;

  const onPlayingChange = useCallback((id: string, playing: boolean) => {
    setPlayingId((current) => {
      if (playing) return id;
      return current === id ? null : current;
    });
  }, []);

  const onUnmuteChange = useCallback((id: string, unmuted: boolean) => {
    setUnmutedId((current) => {
      if (unmuted) return id;
      return current === id ? null : current;
    });
  }, []);

  const onOpen = useCallback((item: ShowreelItem) => {
    const index = SHOWREEL_ITEMS.findIndex((entry) => entry.id === item.id);
    if (index < 0) return;
    setPlayingId(null);
    setUnmutedId(null);
    setDialogIndex(index);
  }, []);

  const onClose = useCallback(() => setDialogIndex(null), []);

  const onPrev = useCallback(() => {
    setDialogIndex((current) => {
      if (current === null || SHOWREEL_ITEMS.length === 0) return current;
      return (current - 1 + SHOWREEL_ITEMS.length) % SHOWREEL_ITEMS.length;
    });
  }, []);

  const onNext = useCallback(() => {
    setDialogIndex((current) => {
      if (current === null || SHOWREEL_ITEMS.length === 0) return current;
      return (current + 1) % SHOWREEL_ITEMS.length;
    });
  }, []);

  if (SHOWREEL_ITEMS.length === 0) {
    return (
      <p className="font-mono text-[11px] tracking-[0.12em] uppercase text-white/35 m-0">
        Videos coming soon.
      </p>
    );
  }

  return (
    <>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 list-none m-0 p-0">
        {SHOWREEL_ITEMS.map((item) => (
          <li key={item.id}>
            <ShowreelTile
              item={item}
              isActivePlayer={!dialogOpen && playingId === item.id}
              isUnmuted={!dialogOpen && unmutedId === item.id}
              dialogOpen={dialogOpen}
              onPlayingChange={onPlayingChange}
              onUnmuteChange={onUnmuteChange}
              onOpen={onOpen}
            />
          </li>
        ))}
      </ul>
      {dialogItem ? (
        <ShowreelModal
          item={dialogItem}
          onClose={onClose}
          onPrev={onPrev}
          onNext={onNext}
        />
      ) : null}
    </>
  );
}
